"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTypography = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = require("react");
var Title = antd_1.Typography.Title, Paragraph = antd_1.Typography.Paragraph, Text = antd_1.Typography.Text;
var tailwindColorMap = {
    default: '!text-gray-800',
    primary: '!text-primary',
    secondary: '!text-gray-500',
    success: '!text-green-600',
    warning: '!text-yellow-600',
    danger: '!text-red-600',
    white: '!text-white',
};
var ACTypography = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'p' : _b, label = _a.label, _c = _a.color, color = _c === void 0 ? 'default' : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.lineClamp, lineClamp = _e === void 0 ? 0 : _e;
    var colorClass = tailwindColorMap[color] || tailwindColorMap.default;
    var combinedClassName = "".concat(colorClass, " ").concat(className).trim();
    var textRef = (0, react_1.useRef)(null);
    var _f = (0, react_1.useState)(false), isTruncated = _f[0], setIsTruncated = _f[1];
    (0, react_1.useEffect)(function () {
        if (!lineClamp)
            return;
        var checkTruncation = function () {
            var el = textRef.current;
            if (!el)
                return;
            setIsTruncated(el.scrollHeight > el.clientHeight + 1); // +1 to avoid rounding issues
        };
        requestAnimationFrame(checkTruncation);
        window.addEventListener('resize', checkTruncation);
        return function () { return window.removeEventListener('resize', checkTruncation); };
    }, [label, lineClamp]);
    if (type.startsWith('h')) {
        var level = parseInt(type === null || type === void 0 ? void 0 : type[1], 10) || 1;
        return ((0, jsx_runtime_1.jsx)(Title, { level: level, style: { margin: 0 }, className: combinedClassName, children: label }));
    }
    var Content = type === 'p' ? Paragraph : Text;
    var textElement = ((0, jsx_runtime_1.jsx)("div", { ref: textRef, style: {
            display: lineClamp > 0 ? '-webkit-box' : 'block',
            WebkitLineClamp: lineClamp || undefined,
            WebkitBoxOrient: 'vertical',
            overflow: lineClamp > 0 ? 'hidden' : 'visible',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            maxWidth: '100%',
            fontWeight: type === 'p' ? 500 : undefined,
            fontSize: type === 'p' ? undefined : '12px',
            cursor: isTruncated ? 'pointer' : 'default',
            margin: 0,
        }, children: label }));
    var wrappedElement = (0, jsx_runtime_1.jsx)(Content, { style: { margin: 0 }, className: combinedClassName, children: textElement });
    if (lineClamp > 0 && isTruncated) {
        return ((0, jsx_runtime_1.jsx)(antd_1.Popover, { content: (0, jsx_runtime_1.jsx)("div", { className: "max-w-[300px] p-2 ".concat(className), children: label }), placement: 'top', children: wrappedElement }));
    }
    return wrappedElement;
};
exports.ACTypography = ACTypography;
